export default {
  send(url, data) {
    return new Promise(resolve => {
      $.post(url, data, resolve)
    })
  },
}
